// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ThreadViewMessagePlaceholder extends Component {
  render() {
    return /*#__PURE__*/_jsxs(Flex, {
      paddingInline: "500",
      paddingBlockStart: "500",
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(SkeletonCircle, {
        marginInlineEnd: "200",
        use: "on-shade"
      }), /*#__PURE__*/_jsx(SkeletonView, {
        inlineSize: "100%",
        blockSize: "90px",
        borderRadius: "200",
        overflow: "hidden",
        use: "on-shade",
        children: /*#__PURE__*/_jsxs(View, {
          padding: "400",
          children: [/*#__PURE__*/_jsx(View, {
            backgroundColor: "fill-surface-default-pressed",
            blockSize: "0.75em",
            inlineSize: "60%"
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "300",
            backgroundColor: "fill-surface-default-pressed",
            blockSize: "0.75em",
            inlineSize: "80%"
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "300",
            backgroundColor: "fill-surface-default-pressed",
            blockSize: "0.75em",
            inlineSize: "100%"
          })]
        })
      })]
    });
  }
}
ThreadViewMessagePlaceholder.displayName = 'ThreadViewMessagePlaceholder';